import * as ActionTypes from '../constants/ActionTypes'

// **************************************************************************************************************
export const cartReducer = (state = {isQueryingAddInitial: false, isFetching: false, isCheckingOut: false, initParams: {initialPromotionCode: false, initialArticles: false, createdFromPreset: false, initialDomains: false}}, action) => {

    // cart is fully synced with server, potential ui states have to be set in extra state

    switch (action.type) {

        case ActionTypes.APP_INITIALIZED:
            return Object.assign({}, state, {
                initParams: action.payload
            })

        case ActionTypes.CART_QUERYPROJECT_START:
            return Object.assign({}, state, {
                isQueryingAddInitial: true
            })

        case ActionTypes.CART_QUERYPROJECT_COMPLETE:
            return Object.assign({}, state, {
                isQueryingAddInitial: false
            })

        case ActionTypes.CART_SET_INITIAL:
            return Object.assign({}, state, {
                initParams: {...state.initParams, [action.key]: action.value}
            });

        case ActionTypes.CART_CHECKOUT_REQUEST:

            return Object.assign({}, state, {isFetching: true, isCheckingOut: true})

        case ActionTypes.CART_REMOVE_ITEM_REQUEST:

            return Object.assign({}, state, {isFetching: true, isSwapping: action.payload && action.payload.isSwapping})

        case ActionTypes.CART_ADD_DOMAIN_REQUEST:
        case ActionTypes.CART_ADD_ITEM_REQUEST:
        case ActionTypes.CART_PUT_FORM_DATA_REQUEST:

            return Object.assign({}, state, {isFetching: true})

        case ActionTypes.CART_ADD_DOMAIN_SUCCESS:
        case ActionTypes.CART_ADD_DOMAIN_FAILURE:
        case ActionTypes.CART_PUT_FORM_DATA_FAILURE:
            return Object.assign({}, state, {isFetching: false})

        case ActionTypes.CART_CHECKOUT_SUCCESS:
        case ActionTypes.CART_CHECKOUT_FAILURE:

            return Object.assign({}, state, {isFetching: false, isCheckingOut: false})

        case ActionTypes.CART_ADD_ITEM_FAILURE:
            return Object.assign({}, state, {isFetching: false})


        case ActionTypes.CART_ADD_ITEM_SUCCESS:

            state = Object.assign({}, state, {isFetching: false, isSwapping: false, isSwappingProgress: false})

        //eslint-disable-next-line
        case ActionTypes.CART_REMOVE_ITEM_SUCCESS:

            state = Object.assign({}, state, {isFetching: false, isSwappingProgress: state.isSwapping ? true : false})

        //eslint-disable-next-line
        case ActionTypes.CART_PUT_FORM_DATA_SUCCESS:

            state = Object.assign({}, state, {isFetching: false, isSwappingProgress: state.isSwappingProgress})

        // eslint-disable-next-line
        case ActionTypes.CART_UPDATE_SUCCESS:
        case ActionTypes.CART_CREATE_SUCCESS:

            if (action.response && action.response.result) {
                // fully import returned cart into state, get methods allow access on it


                return Object.assign({}, {
                        isSwappingProgress: state.isSwappingProgress,
                        isFetching: state.isFetching,
                        isSwapping: state.isSwapping,
                        isCheckingOut: state.isCheckingOut,
                        initParams: state.initParams
                    },
                    action.response.result
                )
            } else {
                return state
            }

        default:
            return state

    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/Cart.js
 **/